import { SessionHandler } from "./SessionHandler.js";

export class UserAPI {
    /**
     * Updates the web settings with whatever info needs storing
     * @param {Object} settings
     * @return {Promise<{Object}>}
     */
    static async updateSettings(settings) {
        let response = await SessionHandler.doFetch("user/settings", {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify(settings),
            redirect: "follow",
        });
        return await response.json();
    }
    static async getSettings() {
        let response = await SessionHandler.doFetch("user/settings", {
            headers: {},
            method: "GET",
            redirect: "follow",
        });
        return await response.json();
    }

    /**
     * Sets the preferred poll times for the user.
     * @param {[Date]} newPollTimes
     * @return {Promise<[Date]>} the newly set poll times.
     */
    static async setPollTimes(newPollTimes) {
        let response = await SessionHandler.doFetch("user/PollTimes", {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify({ PollTimes: newPollTimes }),
            redirect: "follow",
        });
        return await response.json();
    }

    /**
     * Creates an account with the provided information. Admin only.
     * @param {UserInfo} userData
     * @return {Promise<UserInfo>}
     */
    static async addOne(userData) {
        let response = await SessionHandler.doFetch("users", {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "POST",
            redirect: "follow",
            body: JSON.stringify(userData),
        });
        return await response.json();
    }

    /**
     * Gets the users information in the database. Admin only.
     * @param userID
     * @return {Promise<UserInfo>}
     */
    static async getOne(userID) {
        let response = await SessionHandler.doFetch("getUserData/" + userID, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "GET",
            redirect: "follow",
        });
        return await response.json();
    }

    /**
     * Updates the users information in the database. Admin only.
     * @param {String} userID
     * @param {UserInfo} userData
     * @return {Promise<UserInfo>}
     */
    static async updateOne(userID, userData) {
        let response = await SessionHandler.doFetch("users/updateUser/" + userID, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify(userData),
            redirect: "follow",
        });
        return await response.json();
    }
}
